// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3QkKU","title":"Info_title__13nuM","selects":"Info_selects__EP9A3","requiredAsterisk":"Info_requiredAsterisk__1JWCm"};